declare global {
    // eslint-disable-next-line no-unused-vars
    interface Window {
        DD_RUM: LoggingObject | undefined;
    }
}

type TagTypes =
    | 'forms'
    | 'fetch'
    | 'navigation'
    | 'ui'
    | 'login'
    | 'restaurant'
    | 'dynamic-pages'
    | 'gtm-tracking'
    | 'hooks'
    | 'recaptcha'
    | 'pricing'
    | 'lexic'
    | 'cookies'
    | 'email'
    | 'email_syntax'
    | 'email_domain'
    | 'sms_optin';

interface Context {
    searchTerm: string;
    fileName: string;
    tags?: Array<TagTypes>;
    additionalData?: object;
}

interface LoggingObject {
    addAction?(
        // eslint-disable-next-line no-unused-vars
        actionName: string,
        // eslint-disable-next-line no-unused-vars
        context: Context | undefined
    ): void;
    addError?(error: unknown, context: Context | undefined): void;
}

function LoggingHandler() {
    const LOGGINGSERVICEKEY = 'DD_RUM';
    const loggingObject = window[LOGGINGSERVICEKEY] as LoggingObject;

    function isEnabled() {
        return typeof window[LOGGINGSERVICEKEY] !== 'undefined';
    }

    // logs an intentional action from a user in Datadog that isn't already being captured automatically (ex. logging into the site, solving a recaptcha, successfully submitting a form etc.)
    function logUserAction(actionName: string, context?: Context | undefined) {
        if (!isEnabled() || !loggingObject.addAction)
            return (obj: object) =>
                console.warn(`${LOGGINGSERVICEKEY} is not in the DOM.`, obj);
        return loggingObject.addAction(actionName, context);
    }

    // logs an error that is being deliberately thrown in our codebase
    function logError(error: string, context?: Context | undefined) {
        if (!isEnabled() || !loggingObject.addError) {
            return (obj: object) =>
                console.warn(`${LOGGINGSERVICEKEY} is not in the DOM.`, obj);
        }
        return loggingObject.addError(new Error(JSON.stringify(error)), context);
    }

    return {
        logUserAction,
        logError,
    };
}

export { LoggingHandler, TagTypes };
